import { render } from "./CaiDatChung.vue?vue&type=template&id=5f7fd39c&scoped=true"
import script from "./CaiDatChung.vue?vue&type=script&lang=js"
export * from "./CaiDatChung.vue?vue&type=script&lang=js"

import "./CaiDatChung.vue?vue&type=style&index=0&id=5f7fd39c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7fd39c"]])

export default __exports__